import { useLocation } from 'react-router-dom'

export const useSearchParameters = (parameters) => {
  const { search } = useLocation()

  const query = new URLSearchParams(search)
  const result = {}
  parameters.forEach((param) => {
    result[param] = query.get(param)
  })

  return { ...result }
}
